module.exports = __webpack_public_path__ + "static/media/backgammon.54d53504.png";